var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.getLoaderClass},[(_vm.icon)?_c('CustomIcon',{attrs:{"name":_vm.icon}}):_vm._e(),_c('span',{staticClass:"loader-spinner || animate-spin"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }